<ng-template #headerTemplateView>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-xl">
      {{ (tipoServico ? 'BARDO_SERVICOS.EDITAR_CATEGORIA' : 'BARDO_SERVICOS.NOVA_CATEGORIA') | translate }}
    </h3>
  </div>
</ng-template>

<ng-template #footerCriarTemplate>
  <div class="flex w-full align-items-center justify-content-end gap-2 p-3">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      [text]="true"
      severity="secondary"
      (click)="fecharModal()"
      [disabled]="$isLoading()"
    />
    <p-button
      [label]="(tipoServico ? 'GLOBAL.SALVAR' : 'BARDO_SERVICOS.CRIAR_CATEGORIA') | translate"
      icon="pi pi-check"
      (click)="salvar()"
      [loading]="$isLoading()"
    />
  </div>
</ng-template>

@if (deviceService.$isMobile() && $visible()) {
<lib-bottom-sheet
  [visible]="$visible()"
  (visibleChange)="onSheetVisibleChange($event)"
  size="small"
  [draggable]="true"
  [closeOnBackdrop]="!$isLoading()"
  [closeOnEscape]="!$isLoading()"
  [preventClose]="$isLoading()"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="footerCriarTemplate"
  (hide)="fecharModal()"
>
  <div class="flex flex-column gap-4">
    <lib-tipo-servico-criar-editar
      #tipoCriarRef
      [tipoServico]="tipoServico"
      [showButton]="false"
      (salvo)="onCategoriaSalva($event)"
      (loadingChange)="$isLoading.set($event)"
    />
  </div>
</lib-bottom-sheet>
} @else {
<p-dialog
  [visible]="$visible()"
  (visibleChange)="onSheetVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [showHeader]="true"
  styleClass="dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ width: '450px' }"
  (onHide)="fecharModal()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>

  @if ($visible()) {
    <div class="flex flex-column gap-4 p-2">
      <lib-tipo-servico-criar-editar
        #tipoCriarRef
        [tipoServico]="tipoServico"
        [showButton]="false"
        (salvo)="onCategoriaSalva($event)"
        (loadingChange)="$isLoading.set($event)"
      />
    </div>
  }

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerCriarTemplate"></ng-container>
  </ng-template>
</p-dialog>
}
